import React, { useEffect, useState } from 'react';
import { BRAND_NAME } from '../../../theme/brand';
import {
    Box,
    Button,
    Card,
    CardBody,
    Text,
    VStack,
    HStack,
    Tabs,
    TabList,
    TabPanels,
    Tab,
    TabPanel,
    Code,
    List,
    ListItem,
    Icon,
    Divider,
    Tag,
    UnorderedList
} from '@chakra-ui/react';
import { CheckIcon, CopyIcon, InfoIcon, CheckCircleIcon } from '@chakra-ui/icons';
import Prism from 'prismjs';
import 'prismjs/components/prism-kotlin';
import 'prismjs/components/prism-gradle';
import 'prismjs/components/prism-java';
import 'prismjs/components/prism-markup'; // for XML
import 'prismjs/themes/prism-tomorrow.css';
import { useNavigate } from 'react-router-dom';
const ReactNativeSDK = ({ data }) => {

    const [copiedSection, setCopiedSection] = useState('');

    const copyToClipboard = (text, section) => {
        navigator.clipboard.writeText(text);
        setCopiedSection(section);
        setTimeout(() => setCopiedSection(''), 2000);
    };

    const CodeBlock = ({ code, section, language = 'javascript' }) => {
        useEffect(() => {
            Prism.highlightAll();
        }, [code]);

        return (
            <Card bg="black" color="white" position="relative" p={4}>
                <CardBody p={0}>
                    <Button
                        position="absolute"
                        top={3}
                        right={3}
                        size="sm"
                        variant="ghost"
                        colorScheme="whiteAlpha"
                        onClick={() => copyToClipboard(code, section)}
                        zIndex={10}
                    >
                        {copiedSection === section ? <CheckIcon w={4} h={4} /> : <CopyIcon w={4} h={4} />}
                    </Button>
                    <Box as="pre" className="language-${language}" style={{ backgroundColor: 'black', textShadow: 'none', color: 'white', padding: '0px', borderRadius: '8px' }}>
                        <code className={`language-${language}`}>{code}</code>
                    </Box>
                </CardBody>
            </Card>
        );
    };

    const ConfigBanner = ({ isConfigured, platform = 'android' }) => {
        const navigate = useNavigate();
        const handleNavigate = (platform) => {
            if (platform === "ios") {
                const fallbackConfig = {
                    team_id: "",
                    key_id: "",
                    bundle_id: ""
                };

                const iosConfiguration =
                    data?.ios_config && Object.keys(data?.ios_config).length > 0
                        ? data?.ios_config
                        : fallbackConfig;

                navigate("/documentation/configure-apn", {
                    state: { iosConfiguration }
                });
            } else {
                navigate("/documentation/configure-push-notification");
            }
        };

        return (

            <>
                {platform === 'android' ? <Box
                    borderRadius="8.75px"
                    border="1px solid"
                    borderColor={isConfigured ? "#00c951" : "#ff8904"}
                    bg={isConfigured ? "#f0fdf4" : "#fff7ed"}
                    p={4}
                    mb={4}
                >
                    <HStack spacing={3} align="center">
                        <Icon
                            as={isConfigured ? CheckCircleIcon : InfoIcon}
                            color={isConfigured ? "green.500" : "orange.500"}
                            boxSize={5}
                        />
                        <Box flex="1">
                            <HStack justify="space-between" align="center">
                                <Box>
                                    <Text fontSize="md" fontWeight="semibold" color={isConfigured ? "green.800" : "orange.800"} mb={1}>
                                        Push Notification {isConfigured ? "Configured" : "Not Configured"}
                                    </Text>
                                    <Text fontSize="sm" color={isConfigured ? "green.700" : "orange.700"}>
                                        {isConfigured
                                            ? "Your push notification service is successfully configured and ready to use."
                                            : "Configure your push notification service to enable real-time notifications."}
                                    </Text>
                                </Box>
                                <HStack spacing={3}>
                                    <Button
                                        bg={isConfigured ? "#00a63e" : "var(--brand-primary)"}
                                        variant="solid"
                                        size="sm"
                                        color="white"
                                        fontWeight="semibold"
                                        onClick={() => handleNavigate(platform)}
                                        _hover={{ opacity: 0.9 }}
                                    >
                                        {isConfigured ? "Re-Configure" : "Configure"}
                                    </Button>
                                </HStack>
                            </HStack>
                        </Box>
                    </HStack>
                </Box> : <Box
                    borderRadius="8.75px"
                    border="1px solid"
                    borderColor={isConfigured ? "#00c951" : "#ff8904"}
                    bg={isConfigured ? "#f0fdf4" : "#fff7ed"}
                    p={4}
                    mb={4}
                >
                    <HStack spacing={3} align="center">
                        <Icon
                            as={isConfigured ? CheckCircleIcon : InfoIcon}
                            color={isConfigured ? "green.500" : "orange.500"}
                            boxSize={5}
                        />
                        <Box flex="1">
                            <HStack justify="space-between" align="center">
                                <Box>
                                    <Text fontSize="md" fontWeight="semibold" color={isConfigured ? "green.800" : "orange.800"} mb={1}>
                                        {isConfigured ? "Configured" : "Configure"} Apple Push Notification (APN)
                                    </Text>
                                    <Text fontSize="sm" color={isConfigured ? "green.700" : "orange.700"}>
                                        {isConfigured
                                            ? "Your push notification service is successfully configured and ready to use."
                                            : "Configure your push notification service to enable real-time notifications."}
                                    </Text>
                                </Box>
                                <HStack spacing={3}>
                                    <Button
                                        bg={isConfigured ? "#00a63e" : "var(--brand-primary)"}
                                        variant="solid"
                                        size="sm"
                                        color="white"
                                        fontWeight="semibold"
                                        onClick={() => handleNavigate(platform)}
                                        _hover={{ opacity: 0.9 }}
                                    >
                                        {isConfigured ? "Re-Configure" : "Configure"}
                                    </Button>
                                </HStack>
                            </HStack>
                        </Box>
                    </HStack>
                </Box>}


            </>
        )
    }

    return (
        <Box minH="100vh" >
            <Box >
                <VStack spacing={6} align="stretch">
                    {/* Header */}
                    <Box mb={4}>
                        <HStack justify="space-between" align="center" mb={2}>
                            <Text fontSize={"2xl"} fontWeight={"semibold"}>React Native SDK Integration</Text>
                            <Tag bg={"#61dafb"} color={"white"} fontSize={"xs"}>
                                React Native
                            </Tag>
                        </HStack>
                        <Divider />
                    </Box>

                    <Text color="gray.700" fontSize="md">
                        This guide provides step-by-step instructions for integrating the xPush ({BRAND_NAME} Notification Service) SDK into your React Native application, covering setup, permissions, AppDelegate configuration, and JavaScript APIs.
                    </Text>

                    <Text color="gray.700" fontSize={"sm"}>
                        <Text as="span" fontWeight="semibold">React Native Version:</Text> 0.72.0 or higher
                    </Text>

                    <Text color="gray.700" fontSize={"sm"}>
                        <Text as="span" fontWeight="semibold">React Version:</Text> 18.0.0 or higher
                    </Text>

                    {/* Platform Tabs */}
                    <Tabs variant="enclosed">
                        <TabList
                            bg="#f1f5f9"
                            p="1"
                            borderRadius="full"
                            display="flex"
                            justifyContent="space-between"
                            w={"40%"}
                        >
                            <Tab flex="1" _selected={{ bg: "white", boxShadow: "sm", fontWeight: "600" }} borderRadius="full" fontSize="sm" >Android</Tab>
                            <Tab flex="1" _selected={{ bg: "white", boxShadow: "sm", fontWeight: "600" }} borderRadius="full" fontSize="sm" >iOS</Tab>
                        </TabList>

                        <TabPanels>
                            {/* Android Tab */}
                            <TabPanel>
                                <VStack spacing={6} align="stretch" mt={6}>
                                    {/* Config Banner */}
                                    <ConfigBanner isConfigured={data?.android} platform="android" />

                                    {/* Step 1: Install Package */}
                                    <Card p={3} boxShadow={"0 1px 3px 0 #0000001a"} border={"1px solid #0000001a"}>

                                        <VStack spacing={4} align="stretch">
                                            <Text fontSize="xl" fontWeight={"semibold"}>1. Install the Package</Text>
                                            <CodeBlock
                                                code="npm install react-native-xpush"
                                                section="rn-android-install"
                                            />
                                            <Text color="gray.700" fontSize={"sm"}>
                                                This installs the complete Android notification + WebSocket SDK, including Firebase push notification handler, WebSocket listener, Inbox HTML dialog popup, badge counter tracking, auto-reconnect logic, and session/logout helper functions.
                                            </Text>
                                        </VStack>

                                    </Card>

                                    {/* Step 2: Android Setup */}
                                    <Card p={3} boxShadow={"0 1px 3px 0 #0000001a"} border={"1px solid #0000001a"}>

                                        <VStack spacing={6} align="stretch">
                                            <Text fontSize="xl" fontWeight={"semibold"}>2. Android Setup</Text>

                                            <Box>
                                                <Text size="sm" mb={3} fontWeight={"semibold"}>Update AndroidManifest.xml</Text>
                                                <Text color="gray.700" mb={2} fontWeight={"semibold"}>Open:</Text>
                                                <Code display="block" p={2} mb={4}>android/app/src/main/AndroidManifest.xml</Code>

                                                <Text color="gray.700" mb={3} fontSize={"sm"}>Add the following:</Text>
                                                <CodeBlock
                                                    code={`<manifest xmlns:android="http://schemas.android.com/apk/res/android"
          xmlns:tools="http://schemas.android.com/tools">

    <uses-permission android:name="android.permission.INTERNET" />

    <application
        android:name=".MainApplication"
        android:label="@string/app_name"
        android:allowBackup="false"
        android:theme="@style/AppTheme"
        tools:replace="android:theme">

        <!-- 🔔 Firebase Push Service -->
        <service
            android:name="com.xpush.sdk.MyFirebaseMessagingService"
            android:exported="false"
            android:permission="com.google.android.c2dm.permission.SEND">
            <intent-filter>
                <action android:name="com.google.firebase.MESSAGING_EVENT" />
            </intent-filter>
        </service>

        <!-- Other entries -->
    </application>
</manifest>`}
                                                    section="rn-android-manifest"
                                                />
                                            </Box>
                                        </VStack>

                                    </Card>

                                    {/* Step 3: MainActivity Configuration */}
                                    <Card p={3} boxShadow={"0 1px 3px 0 #0000001a"} border={"1px solid #0000001a"}>

                                        <VStack spacing={6} align="stretch">
                                            <Text fontSize="xl" fontWeight={"semibold"}>3. Configure MainActivity</Text>

                                            <Box>
                                                <Text color="gray.700" mb={2}>Open:</Text>
                                                <Code display="block" p={2} mb={4}>android/app/src/main/java/.../MainActivity.kt</Code>

                                                <Text size="sm" mb={3} fontWeight={"semibold"}>Add imports</Text>
                                                <CodeBlock
                                                    code={`import android.content.Intent
import com.xpushmodule.XPushApp
import com.facebook.react.ReactActivityDelegate
import com.facebook.react.defaults.DefaultReactActivityDelegate`}
                                                    section="rn-android-imports"
                                                />
                                            </Box>

                                            <Box>
                                                <Text size="sm" mb={3} fontWeight={"semibold"}>Override createReactActivityDelegate</Text>
                                                <CodeBlock
                                                    code={`override fun createReactActivityDelegate(): ReactActivityDelegate =
    DefaultReactActivityDelegate(this, mainComponentName, fabricEnabled)`}
                                                    section="rn-android-delegate"
                                                />
                                            </Box>

                                            <Box>
                                                <Text size="sm" mb={3} fontWeight={"semibold"}>Handle push notification tap</Text>
                                                <CodeBlock
                                                    code={`override fun onNewIntent(intent: Intent) {
    super.onNewIntent(intent)
    setIntent(intent)

    val readMessageId = intent.getStringExtra("read_message_id")
    if (readMessageId != null) {
        XPushApp.checkMessageById(this, readMessageId)
        sendEventToReact("onNotificationClick", readMessageId)
    }
}`}
                                                    section="rn-android-onNewIntent"
                                                />
                                            </Box>

                                            <Box>
                                                <Text size="sm" mb={3} fontWeight={"semibold"}>Handle WebSocket reconnect on app resume</Text>
                                                <CodeBlock
                                                    code={`override fun onResume() {
    super.onResume()
    XPushApp.setAppForeground(true)
    XPushApp.startSocket()
}`}
                                                    section="rn-android-onResume"
                                                />
                                                <Text color="gray.600" mt={3} >
                                                    This ensures the WebSocket restarts when the app returns to the foreground.
                                                </Text>
                                            </Box>
                                        </VStack>

                                    </Card>

                                    {/* Step 4: MainApplication Configuration */}
                                    <Card p={3} boxShadow={"0 1px 3px 0 #0000001a"} border={"1px solid #0000001a"}>

                                        <VStack spacing={6} align="stretch">
                                            <Text fontSize="xl" fontWeight={"semibold"}>4. Configure MainApplication</Text>

                                            <Box>
                                                <Text color="gray.700" mb={2}>Open:</Text>
                                                <Code display="block" p={2} mb={4}>android/app/src/main/java/.../MainApplication.kt</Code>

                                                <Text size="sm" mb={3} fontWeight={"semibold"}>Add imports</Text>
                                                <CodeBlock
                                                    code={`import com.xpushmodule.XPushApp
import com.xpushmodule.XpushPackage`}
                                                    section="rn-android-app-imports"
                                                />
                                            </Box>

                                            <Box>
                                                <Text size="sm" mb={3} fontWeight={"semibold"}>Update MainApplication class</Text>
                                                <CodeBlock
                                                    code={`class MainApplication : Application(), ReactApplication {

  override val reactHost: ReactHost by lazy {
    getDefaultReactHost(
      context = applicationContext,
      packageList = PackageList(this).packages.apply {
        add(XpushPackage())   // Add SDK manually
      },
    )
  }

  override fun onCreate() {
    super.onCreate()

    XPushApp.initialize(this)
    XPushApp.setLaunchActivity(MainActivity::class.java)

    loadReactNative(this)
  }
}`}
                                                    section="rn-android-app-class"
                                                />
                                                <Text color="gray.700" mt={3}>
                                                    This initializes Firebase, WebSocket manager, Inbox dialog manager, and notification handlers.
                                                </Text>
                                            </Box>
                                        </VStack>

                                    </Card>

                                    {/* Step 5: React Native Usage */}
                                    <Card p={3} boxShadow={"0 1px 3px 0 #0000001a"} border={"1px solid #0000001a"}>

                                        <VStack spacing={4} align="stretch">
                                            <Text fontSize="xl" fontWeight={"semibold"}>5. Use the SDK in React Native</Text>
                                            <CodeBlock
                                                code="import Xpush from 'react-native-xpush';"
                                                section="rn-android-import-sdk"
                                            />
                                        </VStack>

                                    </Card>

                                    {/* Step 6: SDK Methods */}
                                    <Card p={3} boxShadow={"0 1px 3px 0 #0000001a"} border={"1px solid #0000001a"}>

                                        <VStack spacing={6} align="stretch">
                                            <Text fontSize="xl" fontWeight={"semibold"}>6. SDK Methods</Text>

                                            <Box>
                                                <Text size="sm" mb={2} fontWeight={"semibold"}>Xpush.initialize(phone, propertyId)</Text>
                                                <Text color="gray.700" mb={3} fontSize={"sm"}>
                                                    Call once after login. This will register device with backend, get device FCM token, start WebSocket, enable Inbox popup dialog, and track unread counter.
                                                </Text>
                                                <CodeBlock
                                                    code="Xpush.initialize(userPhone, propertyId);"
                                                    section="rn-android-initialize"
                                                />
                                            </Box>

                                            <Box>
                                                <Text size="sm" mb={2} fontWeight={"semibold"}>Xpush.openNotifications()</Text>
                                                <Text color="gray.700" mb={3} fontSize={"sm"}>
                                                    Opens built-in native Notification List screen. Use this when user taps your 🔔 bell.
                                                </Text>
                                                <CodeBlock
                                                    code="Xpush.openNotifications();"
                                                    section="rn-android-open"
                                                />
                                            </Box>

                                            <Box>
                                                <Text size="sm" mb={2} fontWeight={"semibold"}>Xpush.logoutAndDisconnect()</Text>
                                                <Text color="gray.700" mb={3} fontSize={"sm"}>
                                                    Stops WebSocket, clears saved user session, unsubscribes device, and removes pending popups.
                                                </Text>
                                                <CodeBlock
                                                    code="Xpush.logoutAndDisconnect();"
                                                    section="rn-android-logout"
                                                />
                                            </Box>
                                        </VStack>

                                    </Card>

                                    {/* Step 7: Notification Count Listener */}
                                    <Card p={3} boxShadow={"0 1px 3px 0 #0000001a"} border={"1px solid #0000001a"}>

                                        <VStack spacing={4} align="stretch">
                                            <Text fontSize="xl" fontWeight={"semibold"}>7. Notification Count Listener</Text>
                                            <Text color="gray.700" fontSize={"sm"}>
                                                SDK emits <Code>NotificationCountUpdated</Code> whenever new notification arrives, notification list opens, or unread count changes.
                                            </Text>
                                            <CodeBlock
                                                code={`import { NativeEventEmitter } from 'react-native';

const emitter = new NativeEventEmitter(Xpush);

const sub = emitter.addListener("NotificationCountUpdated", event => {
    setNotifCount(event.count);
});`}
                                                section="rn-android-listener"
                                            />
                                        </VStack>

                                    </Card>

                                    {/* Step 8: In-App Popup Dialog */}
                                    <Card p={3} boxShadow={"0 1px 3px 0 #0000001a"} border={"1px solid #0000001a"}>

                                        <VStack spacing={4} align="stretch">
                                            <Text fontSize="xl" fontWeight={"semibold"}>8. Inbox Popup Dialog</Text>
                                            <Text color="gray.700" fontSize={"sm"}>
                                                SDK automatically receives encrypted HTML, decrypts via native code, displays popup through a new Android window, and closes without affecting RN UI. No UI code is needed from the developer.
                                            </Text>
                                        </VStack>

                                    </Card>

                                    {/* Step 9: Typical App Flow */}
                                    <Card p={3} boxShadow={"0 1px 3px 0 #0000001a"} border={"1px solid #0000001a"}>

                                        <VStack spacing={6} align="stretch">
                                            <Text fontSize="xl" fontWeight={"semibold"}>9. Typical App Flow</Text>

                                            <Box>
                                                <Text size="sm" mb={3} fontWeight={"semibold"}>After Login</Text>
                                                <CodeBlock
                                                    code={`await AsyncStorage.setItem("user_phone", phone);

useEffect(() => {
  if (phone) initializeSDK();
}, [phone]);

const initializeSDK = () => {
  setTimeout(() => {
    Xpush.initialize(phone, propertyId);
  }, 1000);  // ensures stable WebSocket + FCM
};`}
                                                    section="rn-android-flow-login"
                                                />
                                            </Box>

                                            <Box>
                                                <Text size="sm" mb={3} fontWeight={"semibold"}>Listen to unread count</Text>
                                                <CodeBlock
                                                    code={`useEffect(() => {
  const sub = new NativeEventEmitter(Xpush).addListener(
    "NotificationCountUpdated",
    event => setNotifCount(event.count)
  );
  return () => sub.remove();
}, []);`}
                                                    section="rn-android-flow-count"
                                                />
                                            </Box>

                                            <Box>
                                                <Text size="sm" mb={3} fontWeight={"semibold"}>Open notifications UI</Text>
                                                <CodeBlock
                                                    code="<TouchableOpacity onPress={() => Xpush.openNotifications()}>"
                                                    section="rn-android-flow-open"
                                                />
                                            </Box>

                                            <Box>
                                                <Text size="sm" mb={3} fontWeight={"semibold"}>Logout</Text>
                                                <CodeBlock
                                                    code={`Xpush.logoutAndDisconnect();
await AsyncStorage.removeItem("user_phone");`}
                                                    section="rn-android-flow-logout"
                                                />
                                            </Box>
                                        </VStack>

                                    </Card>
                                </VStack>
                            </TabPanel>

                            {/* iOS Tab */}
                            <TabPanel>
                                <VStack spacing={10} align="stretch" mt={6}>
                                    {/* Config Banner */}
                                    <ConfigBanner isConfigured={data?.ios} platform="ios" />

                                    {/* Step 1: Install Package */}
                                    <Card p={3} boxShadow={"0 1px 3px 0 #0000001a"} border={"1px solid #0000001a"}>

                                        <VStack spacing={4} align="stretch">
                                            <Text fontSize="xl" fontWeight={"semibold"}>1. Install the Package</Text>
                                            <CodeBlock
                                                code="npm install react-native-xpush"
                                                section="rn-install"
                                            />
                                            <Text color="gray.700" fontSize={"sm"}>
                                                React Native autolinking will link the native iOS module. For CocoaPods you must run <Code>pod install</Code> afterwards.
                                            </Text>
                                        </VStack>

                                    </Card>

                                    {/* Step 2: Xcode Setup */}
                                    <Card p={3} boxShadow={"0 1px 3px 0 #0000001a"} border={"1px solid #0000001a"}>

                                        <VStack spacing={4} align="stretch">
                                            <Text fontSize="xl" fontWeight={"semibold"}>2. Xcode & Project Setup (required)</Text>

                                            <Box>
                                                <Text color="gray.700" mb={2}>Open workspace:</Text>
                                                <Code display="block" p={2}>ios/&lt;YourProject&gt;.xcworkspace</Code>
                                            </Box>

                                            <Box mt={6}>
                                                <Text size="sm" mb={2} fontWeight={"semibold"}>Enable Capabilities</Text>
                                                <Text color="gray.700" mb={2}>In your Xcode project target → Signing & Capabilities add:</Text>
                                                <UnorderedList spacing={2} ml={4}>
                                                    <ListItem>
                                                        <Text fontWeight="semibold" as="span">Push Notifications</Text>
                                                    </ListItem>
                                                    <ListItem>
                                                        <Text fontWeight="semibold" as="span">Background Modes</Text> → enable:
                                                        <List spacing={1} ml={6} mt={1}>
                                                            <ListItem>Background fetch</ListItem>
                                                            <ListItem>Remote notifications</ListItem>
                                                        </List>
                                                    </ListItem>
                                                </UnorderedList>
                                                <Text color="gray.600" mt={2} fontStyle="italic">
                                                    These enable silent pushes and background WebSocket behavior.
                                                </Text>
                                            </Box>

                                            <Box mt={6}>
                                                <Text size="sm" mb={2} fontWeight={"semibold"}>Configure App ID & Provisioning</Text>
                                                <UnorderedList spacing={1} ml={4}>
                                                    <ListItem>Make sure your App ID has Push Notifications enabled</ListItem>
                                                    <ListItem>Upload APNs certificate or (recommended) APNs Auth Key to Firebase if you use FCM → APNs mapping</ListItem>
                                                </UnorderedList>
                                            </Box>

                                            <Box mt={6}>
                                                <Text size="sm" mb={2} fontWeight={"semibold"}>Add entitlements if required</Text>
                                                <Text color="gray.700" fontSize={"sm"}>
                                                    If you need background fetch or remote notifications, ensure *.entitlements reflect enabled capabilities. Xcode usually handles this for you.
                                                </Text>
                                            </Box>
                                        </VStack>

                                    </Card>

                                    {/* Step 3: CocoaPods */}
                                    <Card p={3} boxShadow={"0 1px 3px 0 #0000001a"} border={"1px solid #0000001a"}>

                                        <VStack spacing={4} align="stretch">
                                            <Text fontSize="xl" fontWeight={"semibold"}>3. CocoaPods</Text>
                                            <Text color="gray.700" fontSize={"sm"}>From the ios folder run:</Text>
                                            <CodeBlock
                                                code={`cd ios
pod install
cd ..`}
                                                section="rn-pods"
                                            />
                                        </VStack>

                                    </Card>

                                    {/* Step 4: AppDelegate Integration */}
                                    <Card p={3} boxShadow={"0 1px 3px 0 #0000001a"} border={"1px solid #0000001a"}>

                                        <VStack spacing={6} align="stretch">
                                            <Box>
                                                <Text size="md" mb={2} fontWeight={"semibold"}>4. AppDelegate Integration (minimal & safe)</Text>
                                                <Text color="gray.700" fontSize={"sm"}>
                                                    You do not need to rewrite your whole AppDelegate. Add a helper extension file that sets up the SDK and APNs.
                                                </Text>
                                            </Box>

                                            <Box>
                                                <Text size="sm" mb={3} fontWeight={"semibold"}>Add AppDelegate+Notification.swift (recommended file)</Text>
                                                <Text color="gray.700" mb={3} fontSize={"sm"}>
                                                    Create a new Swift file <Code>AppDelegate+Notification.swift</Code> and paste:
                                                </Text>
                                                <CodeBlock
                                                    code={`import UIKit
import UserNotifications
import SwiftUI
import NotificationSDK   // replace with actual SDK module import

@objc extension AppDelegate {

  func setupNotificationSDK(_ application: UIApplication,
                            launchOptions: [UIApplication.LaunchOptionsKey: Any]?) {
    // Set UNUserNotificationCenter delegate
    UNUserNotificationCenter.current().delegate = APNsService.shared

    // Ask permission
    UNUserNotificationCenter.current().requestAuthorization(options: [.alert, .badge, .sound]) { granted, error in
      if granted {
        DispatchQueue.main.async {
          application.registerForRemoteNotifications()
        }
      } else {
        print("⚠️ Push notification permission not granted.")
      }
    }

    // SDK-level configuration
    APNsService.shared.configure()

    // Observe SDK notifications
    NotificationCenter.default.addObserver(
      forName: .UPDATE_NOTIFICATION_COUNT,
      object: nil,
      queue: .main
    ) { notification in
        // handle if needed
    }

    // If launched from push, forward payload
    if let userInfo = launchOptions?[.remoteNotification] as? [AnyHashable: Any] {
      UserDefaults.standard.set(true, forKey: "skipFirstInAppMessage")
      APNsService.shared.handlePushPayload(userInfo: userInfo, launchedFromTap: true)
    }
  }

  // Reconnect socket on becoming active
  func applicationDidBecomeActive(_ application: UIApplication) {
    // clear badge
    if #available(iOS 17.0, *) {
      UNUserNotificationCenter.current().setBadgeCount(0, withCompletionHandler: nil)
    } else {
      application.applicationIconBadgeNumber = 0
    }

    // Reconnect logic (example — depends on your StorageManager/SocketService)
    guard let userId = StorageManager.shared.get("current_user_id"),
          let propertyId = StorageManager.shared.get("property_id") else {
        return
    }

    DispatchQueue.main.asyncAfter(deadline: .now() + 0.4) {
      SocketService.shared.start(userId: userId, propertyId: propertyId, apnsToken: APNsService.shared.deviceToken)
    }
  }

  // APNs registration callbacks
  func application(_ application: UIApplication,
                   didRegisterForRemoteNotificationsWithDeviceToken deviceToken: Data) {
    let tokenString = deviceToken.map { String(format: "%02.2hhx", $0) }.joined()
    APNsService.shared.deviceToken = tokenString
    StorageManager.shared.set("apns_token", value: tokenString)
    initializeBellIconIfReady()
  }

  func application(_ application: UIApplication,
                   didFailToRegisterForRemoteNotificationsWithError error: Error) {
    print("❌ APNs registration failed: \\(error.localizedDescription)")
  }

  // Silent push handling
  func application(_ application: UIApplication,
                   didReceiveRemoteNotification userInfo: [AnyHashable: Any],
                   fetchCompletionHandler completionHandler: @escaping (UIBackgroundFetchResult) -> Void) {
    if application.applicationState == .background || application.applicationState == .inactive {
      APNsService.shared.handlePushPayload(userInfo: userInfo, launchedFromTap: false)
    }
    completionHandler(.newData)
  }

  // optional helpers called above
  private func initializeBellIconIfReady() {
    guard let token = APNsService.shared.deviceToken,
          let userId = StorageManager.shared.get("current_user_id"),
          let propertyId = StorageManager.shared.get("property_id") else { return }

    DispatchQueue.main.asyncAfter(deadline: .now() + 1.0) {
      BellIconSDK.shared.initialize(phone: userId, propertyId: propertyId)
    }
  }
}`}
                                                    section="rn-appdelegate-ext"
                                                />
                                                <Text color="gray.600" mt={3} fontStyle="italic">
                                                    <Text as="span" fontWeight="semibold">Note:</Text> Replace the SDK type names (e.g. APNsService, SocketService, BellIconSDK, StorageManager) with the exact class names used in your Swift SDK.
                                                </Text>
                                            </Box>

                                            <Box>
                                                <Text size="sm" mb={3} fontWeight={"semibold"}>Call setupNotificationSDK from your AppDelegate</Text>
                                                <Text color="gray.700" mb={3} fontSize={"sm"}>
                                                    In your <Code>AppDelegate.swift</Code> where you set up React Native, add the call:
                                                </Text>
                                                <CodeBlock
                                                    code={`// inside application(_:didFinishLaunchingWithOptions:)
setupNotificationSDK(application, launchOptions: launchOptions)`}
                                                    section="rn-call-setup"
                                                />
                                                <Text color="gray.700" mt={3}>This ensures APNs and SDK are configured on startup.</Text>
                                            </Box>
                                        </VStack>

                                    </Card>

                                    {/* Step 5: SceneDelegate */}
                                    <Card p={3} boxShadow={"0 1px 3px 0 #0000001a"} border={"1px solid #0000001a"}>

                                        <Text size="md" mb={3} fontWeight={"semibold"}>5. SceneDelegate (if using Scenes)</Text>
                                        <Text color="gray.700" fontSize={"sm"}>
                                            If your app uses SceneDelegate, keep SDK initialization in <Code>AppDelegate.application(_:didFinishLaunchingWithOptions:)</Code>. Scene-based lifecycle still works with NotificationCenter observers.
                                        </Text>

                                    </Card>

                                    {/* Step 6: Info.plist */}
                                    <Card p={3} boxShadow={"0 1px 3px 0 #0000001a"} border={"1px solid #0000001a"}>

                                        <VStack spacing={4} align="stretch">
                                            <Text fontSize="xl" fontWeight={"semibold"}>6. Info.plist Keys (optional/helpful)</Text>
                                            <Text color="gray.700" fontSize={"sm"}>Add or confirm these keys in Info.plist if your SDK or dialogs need them:</Text>
                                            <UnorderedList spacing={1} ml={4}>
                                                <ListItem>
                                                    <Text fontWeight="semibold" as="span">UIBackgroundModes</Text> → fetch, remote-notification
                                                </ListItem>
                                                <ListItem>
                                                    <Text fontWeight="semibold" as="span">FirebaseAppDelegateProxyEnabled</Text> → YES (if using Firebase automatic swizzling)
                                                </ListItem>
                                            </UnorderedList>
                                        </VStack>

                                    </Card>

                                    {/* Step 7: Recap */}
                                    <Card p={3} boxShadow={"0 1px 3px 0 #0000001a"} border={"1px solid #0000001a"}>

                                        <VStack spacing={4} align="stretch">
                                            <Text fontSize="xl" fontWeight={"semibold"}>7. Add Entitlements & Capabilities (recap)</Text>
                                            <UnorderedList spacing={1} ml={4}>
                                                <ListItem>
                                                    <Text fontWeight="semibold" as="span">Push Notifications</Text> (Signing & Capabilities)
                                                </ListItem>
                                                <ListItem>
                                                    <Text fontWeight="semibold" as="span">Background Modes</Text> → Remote notifications, Background fetch
                                                </ListItem>
                                            </UnorderedList>
                                        </VStack>

                                    </Card>

                                    {/* Step 8: JS API */}
                                    <Card p={3} boxShadow={"0 1px 3px 0 #0000001a"} border={"1px solid #0000001a"}>

                                        <VStack spacing={6} align="stretch">
                                            <Text fontSize="xl" fontWeight={"semibold"}>8. JS API (React Native usage)</Text>

                                            <Box>
                                                <Text size="sm" mb={2} fontWeight={"semibold"}>Importing</Text>
                                                <CodeBlock
                                                    code="import Xpush from 'react-native-xpush';"
                                                    section="rn-import"
                                                />
                                            </Box>

                                            <Box>
                                                <Text size="sm" mb={2} fontWeight={"semibold"}>Initialize (call once after login)</Text>
                                                <CodeBlock
                                                    code={`Xpush.initialize(userPhone, propertyId);

// Add a small delay after login to ensure React components mount
// and APNs token is available:
setTimeout(() => Xpush.initialize(userPhone, propertyId), 1000);`}
                                                    section="rn-init"
                                                />
                                            </Box>

                                            <Box>
                                                <Text size="sm" mb={2} fontWeight={"semibold"}>Open Notifications UI</Text>
                                                <CodeBlock
                                                    code="Xpush.openNotifications();"
                                                    section="rn-open"
                                                />
                                            </Box>

                                            <Box>
                                                <Text size="sm" mb={2} fontWeight={"semibold"}>Logout / cleanup</Text>
                                                <CodeBlock
                                                    code="Xpush.logoutAndDisconnect();"
                                                    section="rn-logout"
                                                />
                                            </Box>

                                            <Box>
                                                <Text size="sm" mb={2} fontWeight={"semibold"}>Listen Events</Text>
                                                <Text color="gray.700" mb={3} fontSize={"sm"}>
                                                    iOS emits <Code>{`{ count: <number> }`}</Code> shape for NotificationCountUpdated.
                                                </Text>
                                                <CodeBlock
                                                    code={`import { NativeEventEmitter, NativeModules } from 'react-native';

const emitter = new NativeEventEmitter(NativeModules.XpushModule || NativeModules.Xpush);

const sub = emitter.addListener("NotificationCountUpdated", data => {
  console.log('count', data.count);
});

// remove
sub.remove();`}
                                                    section="rn-events"
                                                />
                                            </Box>
                                        </VStack>

                                    </Card>
                                </VStack>
                            </TabPanel>
                        </TabPanels>
                    </Tabs>
                </VStack>
            </Box>
        </Box>
    );
};

export default ReactNativeSDK;